module.exports = __webpack_public_path__ + "static/img/dq5.ffb784b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq5.png
// module id = 0YZE
// module chunks = 0